import mdBasics from './basics.md';
import mdControls from './controls.md';
import mdSettings from './settings.md';

export const helptext = [mdBasics, mdControls, mdSettings];

export default helptext;
